import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { MultiColumnRichTextEntry } from "frontend/contentful/schema/blocks";
import { MultiColumnRichText } from "design-system/components/blocks/multi-column-rich-text/multi-column-rich-text";
import { createMultiColumnRichTextProps } from "./multi-column-rich-text.props";

export interface MultiColumnRichTextOptions {
  headerAbove?: boolean;
}

export const ContentfulMultiColumnRichText = createContentfulComponent<
  MultiColumnRichTextEntry,
  MultiColumnRichTextOptions
>(({ entry, options }) => {
  const props = createMultiColumnRichTextProps(entry, options);

  return <MultiColumnRichText {...props} />;
});
